"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const buildBaseValidationError = ({ path, expectedTypeName, actualValue, }) => {
    const pathString = path.length < 1 ? '' : `:Path: ${path.join('.')}`;
    const error = new Error(`Expecting: ${expectedTypeName}, recieved: ${actualValue} ${pathString}`);
    error.expectedTypeName = expectedTypeName;
    error.path = path;
    return error;
};
exports.default = buildBaseValidationError;
